/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Render_Audio_Failed_ToastInputs */

const en_render_audio_failed_toast = /** @type {(inputs: Render_Audio_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Converting text to speech audio failed. ${i?.error}`)
};

const fr_render_audio_failed_toast = /** @type {(inputs: Render_Audio_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la conversion du texte en audio. ${i?.error}`)
};

const de_render_audio_failed_toast = /** @type {(inputs: Render_Audio_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Umwandlung von Text in Sprache ist fehlgeschlagen. ${i?.error}`)
};

const it_render_audio_failed_toast = /** @type {(inputs: Render_Audio_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversione del testo in audio vocale non riuscita. ${i?.error}`)
};

const ru_render_audio_failed_toast = /** @type {(inputs: Render_Audio_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось преобразовать текст в аудиозапись. ${i?.error}`)
};

const es_render_audio_failed_toast = /** @type {(inputs: Render_Audio_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al convertir texto a audio de voz. ${i?.error}`)
};

const zh_cn2_render_audio_failed_toast = /** @type {(inputs: Render_Audio_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`文本转语音失败。${i?.error}`)
};

const ja_render_audio_failed_toast = /** @type {(inputs: Render_Audio_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`テキストを音声に変換できませんでした。${i?.error}`)
};

const hi_render_audio_failed_toast = /** @type {(inputs: Render_Audio_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को ऑडियो स्पीच में बदलने में विफलता। ${i?.error}`)
};

const pt_pt2_render_audio_failed_toast = /** @type {(inputs: Render_Audio_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A conversão do texto em áudio de fala falhou. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Converting text to speech audio failed. {error}" |
*
* @param {Render_Audio_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_failed_toast = /** @type {((inputs: Render_Audio_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_failed_toast(inputs)
	if (locale === "de") return de_render_audio_failed_toast(inputs)
	if (locale === "it") return it_render_audio_failed_toast(inputs)
	if (locale === "ru") return ru_render_audio_failed_toast(inputs)
	if (locale === "es") return es_render_audio_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_failed_toast(inputs)
	if (locale === "ja") return ja_render_audio_failed_toast(inputs)
	if (locale === "hi") return hi_render_audio_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_failed_toast(inputs)
	return en_render_audio_failed_toast(inputs)
});